// Customer-facing hosted offer. The Register page is the source of this
// wording; other screens import it instead of hardcoding the prices again.
// Amounts actually charged still come from the subscriptions API / Stripe.

export const HOSTED_YEAR_ONE = '$199/yr';
export const HOSTED_YEAR_ONE_LABEL = '$199 / yr';
export const HOSTED_THEN_MONTHLY = '$79/mo';
export const HOSTED_THEN_MONTHLY_LABEL = '$79 / mo';

// Price clause in the Register pitch, kept as that page already shows it.
export const HOSTED_OFFER_CLAUSE = `${HOSTED_YEAR_ONE} for the first year then ${HOSTED_THEN_MONTHLY_LABEL}`;

export const HOSTED_REGISTER_PITCH =
  `Build, design and test on a free staging site. Only billed when you point your domain at it and go live - ${HOSTED_OFFER_CLAUSE}`;

export const ADD_SITE_OFFER_COPY =
  `Spin up a free staging store. Pay ${HOSTED_YEAR_ONE} for the first year, then ${HOSTED_THEN_MONTHLY_LABEL}, only when you publish.`;

// Shown when a live site has no subscription amount from the API.
export const PLAN_LABEL_FALLBACK = `${HOSTED_YEAR_ONE_LABEL}, then ${HOSTED_THEN_MONTHLY_LABEL}`;

export const BILLING_OFFER_EYEBROW = 'First year';
export const BILLING_OFFER_DETAIL = `Then ${HOSTED_THEN_MONTHLY_LABEL}. Free staging until the domain goes live.`;
